import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { QueryParams } from "@obg/ngx.router";
import { FlowStep } from "@obg/ngx.ui.common";

export interface LoginQueryParams extends QueryParams {
	returnUrl?: string;
	username?: string;
}

export const enum LoginTab {
	Generic = 0,
	BankID = 1,
	SmartId = 2,
}

export const enum LoginFormType {
	Generic = "Generic",
	SmartId = "SmartId",
	SGA = "Sga",
	DGA = "Dga",
}

export interface LoginFormGroup extends UntypedFormGroup {
	controls: {
		username: UntypedFormControl;
		password: UntypedFormControl;
		shouldRememberUser: UntypedFormControl;
		iovationBlackBox: UntypedFormControl;
		fraudToken: UntypedFormControl;
	};
}

export interface NewLoginFlowStep extends FlowStep {
	data: {
		firstTimeLogin: boolean;
		order: number;
		hideClose?: boolean;
	};
}

export const SITE_LOGIN_TRANSLATIONS = {
	translations: [
		"login.username.placeholder",
		"login.password.placeholder",
		"login.rememberEmail.placeholder",
		"login.forgot-password",
		"login.submit",
		"login.e_validation",
		"login.dont-have-account",
		"login.create-account",
		"general.contact-support",
		"general.customer-support-link",
		"general.sign-in",
		"forgot-password.email.emailInvalid",
		"login.e_sessions_login_invalidcredentials",
		"login.e_after_registration",
		"login.e_brokencircuit",
		"login.e_cprnumber_notfound",
		"login.e_customerregistrationtokens",
		"login.e_customerregistrationtokens_invalidcountry",
		"login.e_session_login_dailysessionlimitexpired",
		"login.e_session_login_monthlysessionlimitexpired",
		"login.e_session_login_sessionlimitexpired",
		"login.e_session_login_weeklysessionlimitexpired",
		"login.e_sessions_login",
		"login.e_sessions_login_accountnotverified",
		"login.e_sessions_login_badrequest",
		"login.e_sessions_login_customernotallowed",
		"login.e_sessions_login_customerselfexcluded",
		"login.e_sessions_login_customerselfexcludedfromgamstop",
		"login.e_sessions_login_customerselfexcludedfromsga",
		"login.e_sessions_login_fraudblocked",
		"login.e_sessions_login_invalidcredentials",
		"login.e_sessions_login_latestentitylegalnoticenotaccepted",
		"login.e_sessions_login_maxattemptsreached",
		"login.e_sessions_login_typenotallowed",
		"login.e_sessions_logins_latestentitylegalnoticenotaccepted",
		"login.e_timeout",
		"login.e_unhandled",
		"login.e_validation",
		"login.e_verification_failed_already_in_progress",
		"login.e_verification_failed_expired_transaction",
		"login.e_verification_timeout",
		"login.login-error",
		"login.m_sessions_login_accountvalidated",
		"login.missing-connected-oidc-account",
		"login.progress_event_error",
		"login.registration-login-failed",
	],
};
export interface MfeLoginFlag {
	enabled: boolean;
}
